import { render, staticRenderFns } from "./WholeSalesCotent.vue?vue&type=template&id=57957238&"
import script from "./WholeSalesCotent.vue?vue&type=script&lang=js&"
export * from "./WholeSalesCotent.vue?vue&type=script&lang=js&"
import style0 from "./WholeSalesCotent.vue?vue&type=style&index=0&id=57957238&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports